import {
  Deployment,
  DeploymentConfig,
  DeploymentDeviceFilterOption,
  DeploymentPlan,
  DeploymentPlanMode
} from '@/types/deployment'
import { DeploymentOverview } from '@/types/deploymentGroup'
import { PaginatedResponse, WithListParams } from '@/types/pagination'
import { vpApi } from './vpApi'

export type DeploymentListParams = WithListParams<{
  application_id?: string
  device_id?: string
  stream_id?: string
}>

export const getDeploymentList = async (params?: DeploymentListParams) => {
  const res = await vpApi.get<PaginatedResponse<Deployment[]>>(
    `/v1/deployments/`,
    {
      params
    }
  )

  return res.data
}

export type DeploymentOverviewParams = WithListParams<{
  application_id?: string
  device_id?: string
  stream_id?: string
  group_id?: string
}>

const getDeploymentOverview = async (params?: DeploymentOverviewParams) => {
  const res = await vpApi.get<DeploymentOverview>('/v1/deployments/overview/', {
    params
  })

  return res.data
}

const getDeploymentDeviceFilterOptions = async () => {
  const res = await vpApi.get<DeploymentDeviceFilterOption[]>(
    '/v1/deployments/devices/'
  )

  return res.data
}

type CreateDeploymentResponse = {
  task_id: string | null
  plan?: DeploymentPlan
}

export type DeploymentPlanParams = {
  mode?: DeploymentPlanMode
}

const planDeployment = async (
  data: DeploymentConfig,
  params?: DeploymentPlanParams
) => {
  const res = await vpApi.post<DeploymentPlan>('/v1/deployments/plan/', data, {
    params
  })
  return res.data
}

const createDeployment = async (data: DeploymentConfig) => {
  const res = await vpApi.post<CreateDeploymentResponse>(
    '/v1/deployments/',
    data
  )
  return res.data
}

const updateDeployment = async (data: DeploymentConfig) => {
  const res = await vpApi.put<CreateDeploymentResponse>(
    '/v1/deployments/update-deployments/',
    data
  )
  return res.data
}

const stopDeployment = (deploymentId: string) => {
  return vpApi.post(`/v1/deployments/${deploymentId}/stop/`)
}

const startDeployment = (deploymentId: string) => {
  return vpApi.post(`/v1/deployments/${deploymentId}/start/`)
}

// Removes all camera deployments for an application
const removeAppDeployment = (applicationId: string) => {
  return vpApi.delete(`/v1/deployments/delete-deployments/${applicationId}/`)
}

// Removes individual camera deployment
const removeCameraDeployment = (deploymentId: string) => {
  return vpApi.delete(`/v1/deployments/${deploymentId}/`)
}

export const deploymentApi = {
  getDeploymentList,
  getDeploymentOverview,
  getDeploymentDeviceFilterOptions,
  planDeployment,
  createDeployment,
  updateDeployment,
  stopDeployment,
  startDeployment,
  removeAppDeployment,
  removeCameraDeployment
}
